module.exports = __webpack_public_path__ + "img/tab2.e7940068.png";